import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/VirgilSecurity/virgil-front-end/packages/virgil-docs/src/templates/SnippetTemplate.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "hljs language-java"
      }}>{`CustomPureStorage customPureStorage = `}<span parentName="code" {...{
          "className": "hljs-keyword"
        }}>{`new`}</span>{` CustomPureStorage(`}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"jdbc:custom://localhost/puretest?user=root&password=qwerty"`}</span>{`);

PureContext context = PureContext.createContext(
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"AT.znqRZcOdzybj62Rzer897pX2DZ9KZoYF"`}</span>{`,
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"NM.Qs0YFBS7Mr3Aaa9qn4OCVcNC1wvPCXfUpZNWFCPUOUI="`}</span>{`,
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"BU.MCowBQYDK2VwAyEAKWSBAZbbekJ5Ns36jRcjEiut3rH4rpaCCVnRxcB+d/E="`}</span>{`,
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"SK.1.ieSin9pO6Bx96+RJw/85fARl4fWdD9DfU/JQF+mbdqE=.hMnMH+oIg8eKZNxGq27LYQbzK4gDlvWvMLJh3jBCkRk=.ug2KqJdUl50kYx+/RKcACLCR4zAujSlK6vQMvDKst+w="`}</span>{`,
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"PK.1.BO/YeE7oxlUad1TSpKb3DtudynpwB9miM/+1CsMkmf50qP/QUaYt7pXIxrsyLh38u08p6FFkCWedy/VhA//2MJY=.BPkoDhRO/01QmA8JIVcqxMQKrXfA4agTjBFEm42Lh5NIimcEFWUNWXZwq1Q962rxfkJd7kNZDpm0mlPLeHU+iyI="`}</span>{`,
    customPureStorage,
    `}<span parentName="code" {...{
          "className": "hljs-keyword"
        }}>{`null`}</span>{`);

Pure pure = `}<span parentName="code" {...{
          "className": "hljs-keyword"
        }}>{`new`}</span>{` Pure(context);`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "hljs language-php"
      }}>{`$customPureStorage = `}<span parentName="code" {...{
          "className": "hljs-keyword"
        }}>{`new`}</span>{` CustomPureStorage(`}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"mysql:dbname=puretest;host=localhost"`}</span>{`, `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"root"`}</span>{`, `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"qwerty"`}</span>{`);

$context = PureContext::createCustomContext(
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"AT.znqRZcOdzybj62Rzer897pX2DZ9KZoYF"`}</span>{`,
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"NM.Qs0YFBS7Mr3Aaa9qn4OCVcNC1wvPCXfUpZNWFCPUOUI="`}</span>{`,
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"BU.MCowBQYDK2VwAyEAKWSBAZbbekJ5Ns36jRcjEiut3rH4rpaCCVnRxcB+d/E="`}</span>{`,
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"SK.1.ieSin9pO6Bx96+RJw/85fARl4fWdD9DfU/JQF+mbdqE=.hMnMH+oIg8eKZNxGq27LYQbzK4gDlvWvMLJh3jBCkRk=.ug2KqJdUl50kYx+/RKcACLCR4zAujSlK6vQMvDKst+w="`}</span>{`,
    `}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"PK.1.BO/YeE7oxlUad1TSpKb3DtudynpwB9miM/+1CsMkmf50qP/QUaYt7pXIxrsyLh38u08p6FFkCWedy/VhA//2MJY=.BPkoDhRO/01QmA8JIVcqxMQKrXfA4agTjBFEm42Lh5NIimcEFWUNWXZwq1Q962rxfkJd7kNZDpm0mlPLeHU+iyI="`}</span>{`,
    $customPureStorage);

$pure = `}<span parentName="code" {...{
          "className": "hljs-keyword"
        }}>{`new`}</span>{` Pure($context);`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "hljs language-go"
      }}>{`
customPureStorage := NewCustomPureStorage(`}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"custom://localhost/puretest?user=root&password=qwerty"`}</span>{`)
context, err := purekit.CreateDefaultCloudContext(
	`}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"AT.znqRZcOdzybj62Rzer897pX2DZ9KZoYF"`}</span>{`,
	`}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"NM.Qs0YFBS7Mr3Aaa9qn4OCVcNC1wvPCXfUpZNWFCPUOUI="`}</span>{`,
	`}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"BU.MCowBQYDK2VwAyEAKWSBAZbbekJ5Ns36jRcjEiut3rH4rpaCCVnRxcB+d/E="`}</span>{`,
	`}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"SK.1.ieSin9pO6Bx96+RJw/85fARl4fWdD9DfU/JQF+mbdqE=.hMnMH+oIg8eKZNxGq27LYQbzK4gDlvWvMLJh3jBCkRk=.ug2KqJdUl50kYx+/RKcACLCR4zAujSlK6vQMvDKst+w="`}</span>{`,
	`}<span parentName="code" {...{
          "className": "hljs-string"
        }}>{`"PK.1.BO/YeE7oxlUad1TSpKb3DtudynpwB9miM/+1CsMkmf50qP/QUaYt7pXIxrsyLh38u08p6FFkCWedy/VhA//2MJY=.BPkoDhRO/01QmA8JIVcqxMQKrXfA4agTjBFEm42Lh5NIimcEFWUNWXZwq1Q962rxfkJd7kNZDpm0mlPLeHU+iyI="`}</span>{`,
	customPureStorage)
`}<span parentName="code" {...{
          "className": "hljs-keyword"
        }}>{`if`}</span>{` err != `}<span parentName="code" {...{
          "className": "hljs-literal"
        }}>{`nil`}</span>{` {
	`}<span parentName="code" {...{
          "className": "hljs-comment"
        }}>{`//TODO process error`}</span>{`
}

pure, err := purekit.NewPure(context)
`}<span parentName="code" {...{
          "className": "hljs-keyword"
        }}>{`if`}</span>{` err != `}<span parentName="code" {...{
          "className": "hljs-literal"
        }}>{`nil`}</span>{` {
	`}<span parentName="code" {...{
          "className": "hljs-comment"
        }}>{`//TODO process error`}</span>{`
}`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      